var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center mt-3",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.detail
        ? [
            _c("div", [
              _c("h5", [
                _vm._v("Препарат "),
                _c("strong", [_vm._v(_vm._s(_vm.drug.title))]),
              ]),
              _vm._v(" "),
              _c("h6", [
                _vm._v("редактирование атрибута "),
                _c("strong", [_vm._v(_vm._s(_vm.detail.title))]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("table", { staticClass: "table table-hover table-sm mt-1" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.$AllProjects, function (p) {
                    return p.is_active &&
                      !p.settings.no_site &&
                      _vm.details[p.id]
                      ? _c(
                          "tr",
                          { class: { not_active: !_vm.drugActivity[p.id] } },
                          [
                            _c("td", [_vm._v(_vm._s(p.title))]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                !_vm.drugActivity[p.id]
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          "Препарат не активен на проекте"
                                        ),
                                      ]),
                                    ]
                                  : [
                                      _vm.detail.type === "array"
                                        ? [
                                            _vm.sitesSelects &&
                                            _vm.sitesSelects[p.id]?.options
                                              ? [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options:
                                                        (_vm.sitesSelects &&
                                                          _vm.sitesSelects[p.id]
                                                            ?.options) ||
                                                        [],
                                                      placeholder:
                                                        "Выберите деталь",
                                                      "track-by": "name",
                                                      label: "name",
                                                      showLabels: false,
                                                      searchable: true,
                                                      multiple:
                                                        !!_vm.detail
                                                          .is_multiple,
                                                    },
                                                    on: { input: (e) => {} },
                                                    model: {
                                                      value:
                                                        _vm.details[p.id]
                                                          .array_value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.details[p.id],
                                                          "array_value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "details[p.id].array_value",
                                                    },
                                                  }),
                                                ]
                                              : _vm.allowToCreate
                                              ? [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      "tag-placeholder":
                                                        "Выберите или создайте запись",
                                                      placeholder:
                                                        "Выберите или создайте запись",
                                                      options: [],
                                                      multiple: true,
                                                      taggable: true,
                                                    },
                                                    on: {
                                                      tag: (t) => {
                                                        _vm.details[
                                                          p.id
                                                        ].array_value.push(t)
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.details[p.id]
                                                          .array_value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.details[p.id],
                                                          "array_value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "details[p.id].array_value",
                                                    },
                                                  }),
                                                ]
                                              : [
                                                  _c("p", [
                                                    _vm._v(
                                                      "выбор деталей не найден на проекте"
                                                    ),
                                                  ]),
                                                ],
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.detail.type === "text"
                                        ? [
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.details[p.id].value,
                                                  expression:
                                                    "details[p.id].value",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                rows: "2",
                                                type: "text",
                                              },
                                              domProps: {
                                                value: _vm.details[p.id].value,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.details[p.id],
                                                    "value",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        : _vm._e(),
                                    ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("td"),
                          ]
                        )
                      : _vm._e()
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Сохранить",
                      loading: _vm.btnLoading,
                      color: _vm.$constants.SUCCESS_COLOR,
                      onClick: () => _vm.saveRecords(),
                      className: "btn btn-outline-success",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Проект")]),
        _vm._v(" "),
        _c("th", [_vm._v("Значение")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }